import { Pipe, PipeTransform } from "@angular/core";
import { PercentSymbolPipe } from "@modules/core/pipes/percent-symbol.pipe";
import { AccountService } from "@modules/account/services/account.service";
import { FiatPrecisionSymbolPipe } from "@modules/core/pipes/currency.symbol.precision.pipe";

// This pipe formats percentages according to user fiat settings and also supports more than 2 decimals
// Useful in e.g. BEST, where we want to show and correctly format 0.1%, 0.25%, 0.275%,...
@Pipe({
	name: "percent_symbol_precision",
	standalone: false
})
export class PercentSymbolPrecisionPipe implements PipeTransform {
	constructor(
		private fiatPrecisionPipe: FiatPrecisionSymbolPipe,
		private percentSymbolPipe: PercentSymbolPipe,
		private accountService: AccountService
	) {}

	public transform(value: string | number, showPositivePrefix: boolean = false): string {
		const fiat = this.accountService.getDefaultFiat();

		const fiatPrecisionValue = this.fiatPrecisionPipe.transform(value, {
			currencies: [fiat],
			customPrecision: 4, // Max precision
			cutZeroSuffix: true,
			cutAllZeroSuffix: true, // "cutZeroSuffix" only works above 2 decimals
			symbol: false,
			showPositivePrefix: showPositivePrefix
		});

		return this.percentSymbolPipe.transform(fiatPrecisionValue);
	}
}
